module.exports = __webpack_public_path__ + "img/sy1.c2d9c547.png";